<template>
    <v-icon :size="size" :class="iconClass">insert_drive_file</v-icon>
</template>

<script>

    import { VIcon } from 'vuetify/lib';

    export default {
        name: 'FileIcon',
        components: {
            VIcon
        },
        props: {
            mimetype: String,
            size: String,
            round: Boolean
        },
        data() {
            return {
                iconClass: "",
            }
        },
        watch: {
            mimetype: function () {
                this.render();
            },
        },
        created() {
            this.render();
        },
        methods: {
            render() {
                let color = "grey";

                if (this.mimetype) {
                    if (this.mimetype.includes("pdf")) {
                        color = "orange";
                    } else if (this.mimetype.includes("tif")) {
                        color = "blue";
                    } else {
                        color = "primary";
                    }
                }

                if (this.round) {
                    this.iconClass = color + " white--text";
                } else {
                    this.iconClass = color + "--text";
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>